var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2444 18.6829L16.2754 18.2743M16.2754 15.8181L15.2444 15.4084M18.0894 14.0809L17.6616 13.0935M18.0894 20.0116L17.6616 21M20.6539 14.0809L21.0817 13.0935M21.0806 21L20.6539 20.0116M14.9441 13.0935C13.2283 11.8087 10.3932 11.593 9.00501 11.8087C7.61684 12.0243 6.30142 12.5507 5.16572 13.3451C4.03003 14.1394 3.10612 15.1793 2.46915 16.38C1.83218 17.5808 1.50013 18.9086 1.5 20.2555H13.2283M22.4679 15.8181L23.5 15.4084M22.4679 18.2743L23.5 18.684M16.0207 6.34874C16.0207 9.30276 13.5203 11.6975 10.4358 11.6975C7.35137 11.6975 4.85093 9.30276 4.85093 6.34874C4.85093 3.39471 7.35137 1 10.4358 1C13.5203 1 16.0207 3.39471 16.0207 6.34874ZM22.7226 17.0462C22.7226 18.8186 21.2223 20.2555 19.3716 20.2555C17.521 20.2555 16.0207 18.8186 16.0207 17.0462C16.0207 15.2738 17.521 13.837 19.3716 13.837C21.2223 13.837 22.7226 15.2738 22.7226 17.0462Z",
    stroke: "#054E5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserm);
export default __webpack_public_path__ + "static/media/userm.e0c064155e44eabcaa3ddcf96d129cd9.svg";
export { ForwardRef as ReactComponent };